import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home/Home";
import ContactUs from "./components/Contactus/ContactUs";
import IndustriesPage from "./components/Industries/IndustriesPage";
import CaseStudiesPage from "./components/CaseStudies/CaseStudiesPage";
import AboutUs from "./components/AboutUs/AboutUs";
import SoftwareDevelopment from "./components/Services/SoftwareDevelopment";
import CloudSolutions from "./components/Services/CloudSolutions";
import CyberSecurity from "./components/Services/CyberSecurity";
import ITConsulting from "./components/Services/ITConsulting";
import ManagedITServices from "./components/Services/ManagedITServices";
import Services from "./components/Services/Services";


function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col bg-white">
        <Header />

        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/services/software-development" element={<SoftwareDevelopment/>}/>
            <Route path="/services/cloud-solutions" element={<CloudSolutions/>}/>
            <Route path="/services/cyber-security" element={<CyberSecurity/>}/>
            <Route path="/services/it-consulting" element={<ITConsulting/>}/>
            <Route path="/services/managed-it-services" element={<ManagedITServices/>}/>
            <Route path="/contact" element={<ContactUs />} /> 
          </Routes>
        </main>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;